module.exports = __webpack_public_path__ + "static/media/logo-Vaasa-2022.4c4c71ec.png";